import { SubmitHandler, useForm } from "react-hook-form";

import { Button } from "@design-system/Button/Button";
import { FieldGroup } from "@design-system/FieldGroup/FieldGroup";
import { Form } from "@design-system/Form/Form";
import { TextField } from "@design-system/TextField/TextField";

export type ClientEmployeeFormValues = {
  name: string;
  email: string;
  externalId?: string | null;
};

type Props = {
  submitText?: string;
  onSubmit: SubmitHandler<ClientEmployeeFormValues>;
  values?: ClientEmployeeFormValues;
};

export const ClientEmployeeForm = ({
  submitText = "Submit",
  onSubmit,
  values,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ClientEmployeeFormValues>({
    values: {
      name: values?.name ?? "",
      email: values?.email ?? "",
      externalId: values?.externalId ?? "",
    },
  });

  const handleFormSubmit: SubmitHandler<ClientEmployeeFormValues> = (data) => {
    const processedData = {
      ...data,
      externalId: data.externalId?.trim() === "" ? null : data.externalId,
    };
    onSubmit(processedData);
  };

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)}>
      <FieldGroup label="Name" error={errors.name?.message} required>
        <TextField
          type="text"
          {...register("name", {
            required: { value: true, message: "This field is required" },
          })}
        />
      </FieldGroup>

      <FieldGroup label="Email" error={errors.email?.message} required>
        <TextField
          type="email"
          {...register("email", {
            required: { value: true, message: "This field is required" },
          })}
        />
      </FieldGroup>

      <FieldGroup label="External ID" error={errors.externalId?.message}>
        <TextField type="text" {...register("externalId")} />
      </FieldGroup>

      <Button isLoading={isSubmitting} type="submit">
        {submitText}
      </Button>
    </Form>
  );
};
